import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import { shareStore } from '../Stores/ShareStore';
import { error } from '../Stores/ShareStore/Types';

interface Props {
  isPublished: boolean;
  isPublishing: boolean;
  close: () => void;
}

const DoneButton: React.FC<Props> = ({ isPublished, isPublishing, close }) => {
  // Check if allocate is selected but no license is chosen
  const isAllocateWithoutLicense =
    shareStore.state.kind === 'ready' &&
    shareStore.state.unlicensedAccess === 'allocate' &&
    shareStore.state.selectedLicenseId.isNothing();

  const isDisabled = !isPublished || isPublishing || isAllocateWithoutLicense;

  const handleClick = () => {
    if (!isPublished || isPublishing || isAllocateWithoutLicense) {
      return;
    }

    // Check if advanced settings were modified
    if (shareStore.state.kind === 'ready' && shareStore.state.advancedSettingsModified) {
      // Save advanced settings
      shareStore.saveAdvancedSettings().fork(
        action((err) => {
          console.error('Failed to save advanced settings:', err);
          shareStore.state = error('Failed to save advanced settings. Please try again later.');
        }),
        () => {
          // Success - close the modal
          close();
        },
      );
    } else {
      // No changes to save, just close
      close();
    }
  };

  return (
    <button
      className={`px-8 py-2.5 rounded-md transition-colors font-semibold text-sm leading-5 tracking-normal h-10 ${
        isDisabled
          ? 'bg-gray-200 text-gray-700 cursor-not-allowed'
          : 'bg-teal-600 text-white hover:bg-teal-700'
      }`}
      disabled={isDisabled}
      onClick={handleClick}
      data-intercom-target="share-overlay-done-button"
    >
      <T kind="Done" />
    </button>
  );
};

export default observer(DoneButton);
